import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Table, Icon, Row, Col, Popconfirm, Divider, Button } from 'antd';
import { Animated } from "react-animated-css";
import HeaderContent from '../common/headercontent/HeaderContent';
import moment from 'moment';
import config from '../../config';

import './students.css';

import {
  studentList,
  studentDelete,
  studentGetResult,
} from '../../modules/student';

class Students extends Component {
	constructor(props){
		super(props);
		this.state = {
			addModal: false,
			selectedStudents: null,
      loading: false,
      classQuotaId: this.props.match.params.id,
		}
	}

	componentDidMount() {
		if (!this.props.studentsData) {
			this.getStudents();		
		}
	}

	toggleAddModal = () => {
    const { addModal } = this.state;
    if (addModal) {
      this.setState({selectedStudents: null});
    }
		this.setState({ addModal: !addModal });
	}

	onSelectStudents(studentsId = null) {
		window.scrollTo(0, 0);
		this.setState({ selectedStudents: null });
		setImmediate(()=> {
			this.setState({ selectedStudents: studentsId });
		});
	}

	getStudents() {
    const { classQuotaId } = this.state;
    this.setState({loading: true});
		this.props.studentList(classQuotaId).then(() => {
      this.setState({loading: false});
    })
	}

	onDeleteConfirm(studentsId) {
		const { selectedStudents } = this.state;

		// this.props.studentsDelete(studentsId).then( 
		// 	(res) => {
		// 		if (studentsId === selectedStudents) {
		// 			this.setState({ selectedStudents: null });
		// 		}
		// 		this.getStudents();
		// 	},
		// 	(err) => {
		// 		this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
		// 	}
		// );
	}
  
  onEditStudents = (selected) => {
    this.setState({selectedStudents: selected});
    this.toggleAddModal();
  }

  onReportStudent = (student) => {
    this.goTo(`/report/${student._id}`)
    // this.props.studentGetResult(student._id);
  }

  goTo = (path) => {
    window.location = path;
  }

	render() {
      
		const { addModal, selectedStudents, loading } = this.state;

		const columns = [{
			title: '學生編號',
			dataIndex: 'studentCode',
			key: 'studentCode',
    },
    {
			title: '中文姓名',
			dataIndex: 'studentChineseName',
			key: 'studentChineseName',
    },
    {
			title: '英文姓名',
			dataIndex: 'studentEnglishName',
			key: 'studentEnglishName',
    },
    {
			title: '學號',
			dataIndex: 'studentNumber',
			key: 'studentNumber',
    }
    , {
			title: '進度',
			dataIndex: 'progress',
			key: 'progress',
      render: (text, data) => {
        let index = config.progressStatus.indexOf(text);
        let progress = Math.floor((index / (config.progressStatus.length - 1)) * 100);
        return progress === 100 ? '已完成' : `${progress}%`;
      }
		}, {
			title: '操作',
			key: '操作',
			render: (text, data) => (
			<span>
        {
          data.progress === 'done' &&
          <a onClick={() => this.onReportStudent(data)}>報告</a>
        }
			</span>
		),
		}
	];

		const headerData = {
			// button: {
			// 	title: <span><Icon type="file-add" /> 新增班別/學生</span>,
			// 	function: () => this.toggleAddModal()
			// }
		};
		
		const headerSStudentsData = (selectedStudents) ? {
			close: {
				title: <Icon type="close-square" />,
				function: () => this.onSelectStudents()
			}
		} : "";

		let data = [];
		let sStudents = [];
		if (this.props.studentsData) {
			data = this.props.studentsData.results.map(student => {
				console.log(student);
				return {
					_id: student._id,
          			studentCode: student.studentCode,
          			studentChineseName: student.info.nameChinese,
          			studentEnglishName: student.info.nameEnglish,
          			studentNumber: student.info.classNumber,
          			progress: student.progress,
				}
			});

			sStudents = this.props.studentsData.results.filter(school=>school._id === selectedStudents);
    }

    const sample = this.props.studentsData && this.props.studentsData.results.length > 0 ? this.props.studentsData.results[0] : null;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
					<Col>	
							<HeaderContent title="學生列表" subtitle={sample ? `${sample.school.name_tc} - ${sample.schoolQuota.year} - ${sample.classData.className} (${sample.classData.groupId})` : ''} data={headerData} />
							<Card title={
                <p className="card-title">
                  <span>{`學生列表`}</span>
                  <span>
                    <Button
                      icon={loading ? "loading" : "reload"}
                      disabled={loading ? true : false}
                      onClick={this.getStudents.bind(this)}
                      />
                  </span>
                </p>
              }>
								<Table columns={columns} dataSource={data} />
							</Card>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	studentsData: state.student.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		studentList,
		studentDelete,
    studentGetResult,
	},
	dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Students));